(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cw-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  var roots = document.querySelectorAll('[data-cw-hero-visual]');
  roots.forEach(function (visual) {
    var img = visual.querySelector('[data-cw-hero-img]');
    var label = visual.querySelector('[data-cw-swatch-name]');
    var swatches = visual.querySelectorAll('.cw-swatch');
    swatches.forEach(function (sw) {
      sw.addEventListener('click', function () {
        swatches.forEach(function (s) { s.setAttribute('aria-pressed', 'false'); });
        sw.setAttribute('aria-pressed', 'true');
        if (img && sw.dataset.cwImg) { img.src = sw.dataset.cwImg; img.alt = sw.dataset.cwName || ''; }
        if (label) label.textContent = sw.dataset.cwName || '';
        if (sw.dataset.cwGlow) visual.style.setProperty('--cw-glow', sw.dataset.cwGlow);
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cw-strap"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[data-cw-strap]').forEach(function (root) {
    var img = root.querySelector('[data-cw-strap-img]');
    var name = root.querySelector('[data-cw-strap-name]');
    var swatches = root.querySelectorAll('.cw-strap-swatch');
    swatches.forEach(function (sw) {
      sw.addEventListener('click', function () {
        swatches.forEach(function (s) { s.setAttribute('aria-pressed', 'false'); });
        sw.setAttribute('aria-pressed', 'true');
        if (img && sw.dataset.cwImg) { img.src = sw.dataset.cwImg; img.alt = sw.dataset.cwName || ''; }
        if (name) name.textContent = sw.dataset.cwName || '';
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
